import { useReactiveVar } from "@apollo/client";
import { localRecordingToolPermissionsDeniedState } from "../../../../model";

export type RecordingToolPermissionDeniedType = "camera" | "microphone" | "cameraAndMicrophone"

export const useRecordingToolPermissionDenied = () => {
    const recordingToolPermissionDenied = useReactiveVar(localRecordingToolPermissionsDeniedState);

    const setRecordingToolPermissionDenied = (state: RecordingToolPermissionDeniedType) => {
        localRecordingToolPermissionsDeniedState(state);
    };

    return {
        recordingToolPermissionDenied,
        setRecordingToolPermissionDenied
    };
};

